import MovieTitle from "@/components/poster/MovieTitle";
import PosterWrapper from "@/components/poster/PosterWrapper";
import ShowInfo from "@/components/poster/ShowInfo";
import TextContainer from "@/components/poster/TextContainer";
import ShowTime from "@/components/program/ShowTime";
import { type IPlannedDate, type ISpillested } from "@/lib/kinologg/kinologgTypes";
import classNames from "classnames";
import { parse } from "date-fns";
import {nb as locale} from "date-fns/locale/nb";
import { useMemo } from "react";
import styles from "./PlannedShow.module.css";
import PosterContainerLink from "@/components/poster/PosterContainerLink";
import MissingPoster from "@/components/program/MissingPoster";

//#region [Props]
type PlannedShowProps = {
    location: ISpillested;
    date: IPlannedDate
    className?: string;
};
//#endregion

//#region [Component]
export default function PlannedShow({ location, className, date }: PlannedShowProps) {

    const { numShows, showDate } = useMemo(() => {
        let numShows = 0;
        let showDate;
        if (location.klokkeforste) {
            numShows++;
            showDate = parse(date.dato, "yyyy-MM-dd", new Date(), { locale });
        }
        if (location.klokkeandre) {
            numShows++;
        }

        return { numShows, showDate: showDate! };
    }, [location.klokkeandre, location.klokkeforste, date.dato]);

    if (numShows === 0) {
        return null;
    }

    return <OnePlannedShow location={location} showStart={showDate} numShows={numShows} className={className} />;
}


//#endregion

function OnePlannedShow({ numShows, showStart, className, location }: { numShows: number; showStart: Date; className?: string; location: ISpillested; }) {
    return <PosterWrapper className={classNames(styles.PlannedShow, className)}>
        <PosterContainerLink>
            <MissingPoster/>
        </PosterContainerLink>
        <TextContainer>
            <MovieTitle title="Film kommer" />
            <ShowInfo info={`${location.navn}, ${location.stedsnavn}`} />
            <ShowTime showStart={showStart} dateOnly/>
            <ShowInfo info={`${numShows} forestillinger`} />
        </TextContainer>

    </PosterWrapper>;
}
